import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyLira: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCurrencyLira"><Path d="M8.5 3V20.5H12C15.5899 20.5 18.5 17.5899 18.5 14" stroke="currentColor"/><Path d="M5 12L16 8.5" stroke="currentColor"/><Path d="M5 15L16 11.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconCurrencyLira;
